import { render } from "./ai_query.vue?vue&type=template&id=62069dea&scoped=true"
import script from "./ai_query.vue?vue&type=script&lang=js"
export * from "./ai_query.vue?vue&type=script&lang=js"

import "./ai_query.vue?vue&type=style&index=0&id=62069dea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62069dea"]])

export default __exports__